import { useCallback, useEffect, useState } from 'react';

import { useNavigate } from 'react-router-dom';

interface NavigateFunctionType {
	(path: string): void
	(key: string[], path: string): void
}

export const useMenuNavigate = () => {
	const [ selectedKeys, setSelectedKeys, ] = useState<string[]>([]);
	const routerNavigate = useNavigate();

	const navigate: NavigateFunctionType = useCallback((arg1: string | string[], arg2?: string) => {
		const keys = arg2 !== undefined ? arg1 as string[] : [] as string[];
		const path = arg2 !== undefined ? arg2 : arg1 as string;
        
		const url = new URL(window.location.href);
		url.searchParams.delete('k');
		if(keys.length !== 0){
			keys.forEach(val => {
				url.searchParams.append('k', val);
			});
		}
		routerNavigate(path.concat(url.search));
	}, [ setSelectedKeys, routerNavigate, ]);

	useEffect(() => {
		const url = new URL(window.location.href);
		const keys = url.searchParams.getAll('k');
		if(keys.length !== 0){
			setSelectedKeys(keys);
		}
	}, []);

	return {
		selectedKeys,
		navigate,
	};
};